import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const removeUpsellPageFromCheckoutExperience = {
  name: "removeUpsellPageFromCheckoutExperience" as const,
  input: z.object({ checkoutExperienceId: zExt.objectId() }),
  output: z.null(),
};
